type Props = {
  onBack: (() => void) | null;
  onContinue: () => void;
  canContinue: boolean;
  isBusy?: boolean;
  continueLabel?: string;
  /** Shown next to the buttons — why "Continuar" is disabled, usually. */
  hint?: string;
};

/**
 * The wizard's navigation row, rendered by each step rather than by the shell.
 *
 * Steps own their save, so they own the button that triggers it; passing a callback
 * up to a shell-rendered footer would mean the shell re-rendering on every keystroke
 * of validity state. Sharing the component keeps every step's footer identical.
 */
export function WizardFooter({
  onBack,
  onContinue,
  canContinue,
  isBusy = false,
  continueLabel = "Continuar",
  hint,
}: Props): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-center justify-end gap-3 border-t border-ink-200 pt-4">
      {hint && <span className="mr-auto text-xs text-ink-500">{hint}</span>}
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={isBusy}
          className="rounded-lg border border-ink-200 px-4 py-2 text-sm font-medium text-ink-700 hover:bg-ink-050 disabled:cursor-not-allowed disabled:opacity-40"
        >
          Atrás
        </button>
      )}
      <button
        type="button"
        onClick={onContinue}
        disabled={!canContinue || isBusy}
        className="rounded-lg bg-lime px-4 py-2 text-sm font-semibold text-moss hover:bg-lime-dk disabled:cursor-not-allowed disabled:opacity-40"
      >
        {isBusy ? "Guardando…" : continueLabel}
      </button>
    </div>
  );
}
